var formContattiConfigurabile = (function () {
    function init() {
        var formContatti = $('.form-contatti-configurabile');

        $('.form-contatti-configurabile select.select').select2({
            allowClear: true
        });

        formContatti.each(function () {

            var currentForm = $(this);
            var targetContainers = currentForm.find('.target_custom_data');
            var targetSelect = currentForm.find('select.target-field');
            var attachmentField = currentForm.find('input#attachments-field');
            var currentAttachmentsList = [];

            if (attachmentField.length){
                attachmentField.on('change', function (e) {
                    var files = $(e.target)[0].files;
                    currentForm.find('.row.attachments-row .err').addClass('d-none');
                    currentForm.find('.row.attachments-row .custom-attachment-field-container').removeClass('is-invalid');
                    var errors = validateAttachmentsNumber(currentForm, files);
                    if (Object.keys(errors).length===0){
                        currentAttachmentsList = files;
                        addFilesCards(currentForm, currentAttachmentsList);
                    }else {
                        showErrors(currentForm, errors, '', true);
                    }
                })

                currentForm.find('.row.attachments-row .custom-attachment-field-container .browse-button').on('click', function (e) {
                    attachmentField.trigger('click');
                })
            }

            if (targetSelect.length>0){
                var mainTarget = targetSelect.val().split('_')[0];
                if (mainTarget) {
                    $('.target_custom_data_' + mainTarget, $(this)).removeClass('d-none');
                }

                targetSelect.on('select2:select', function (e) {
                    var mainTarget = $(this).val().split('_')[0];
                    targetContainers.addClass('d-none');
                    targetContainers.find('input:not([type=radio])').val('');
                    var targetRadioButtons = targetContainers.find('input[type=radio]');
                    if (targetRadioButtons.length>0){
                        targetRadioButtons.each(function () {
                            $(this).prop('checked', false);
                        })
                    }
                    targetContainers.find('select').val('').trigger('change');
                    currentForm.find('.target_custom_data.target_custom_data_' + mainTarget).removeClass('d-none');
                });
            }

            $(this).submit(function (e) {
                e.preventDefault();
                currentForm.find('.is-invalid').removeClass('is-invalid');
                currentForm.find('.row.attachments-row .err').addClass('d-none')
                var errors = validateForm(currentForm, currentAttachmentsList);
                if(Object.keys(errors).length===0){
                    var formData = new FormData(this);
                    $.each(currentAttachmentsList,function (index,file) {
                        formData.append('attachments['+index+']', file);
                    });
                    try {
                        $.ajax({
                            url: $(this).attr('action'),
                            type: $(this).attr('method'),
                            contentType: false,
                            processData: false,
                            cache: false,
                            dataType: 'json',
                            data: formData,
                            success: function (json) {
                                manageResponse(json, currentForm);
                            },
                            error: function (xhr, status, error) {
                                if (typeof attachments_ENV !== "undefined" && typeof attachments_ENV !== undefined){
                                    if (Object.keys(attachments_ENV).length>0 && xhr.status===413){
                                        showErrors(currentForm, {
                                            'custom-attachments': [],
                                            'attachments': [attachments_ENV.exceeded_files_limit]
                                        }, attachments_ENV.exceeded_files_limit);
                                    }
                                }else {
                                    showErrors(currentForm, [], 'Internal error, please try again later');
                                }
                            }
                        });
                    }catch (e) {
                        showErrors(currentForm, [], 'Internal error, please try again later');
                        console.log('exception')
                    }
                }else{
                    showErrors(currentForm, errors, '');
                }
            });

            function addFilesCards(form) {
                var attachmentsListContainer = form.find('.row.attachments-row .attachments-list');
                attachmentsListContainer.addClass('d-none');
                attachmentsListContainer.find('.single-attachment-container').remove();
                var cardTemplate = form.find('.row.attachments-row .single-attachment-container');

                for (var i=0; i < currentAttachmentsList.length; i++){
                    var currentFile = currentAttachmentsList[i];
                    var fileTemplate = cardTemplate.clone();
                    fileTemplate.find('.file-name').text(currentFile.name);
                    fileTemplate.find('.file-size').text(((currentFile.size/1000000).toFixed(2)) + ' ' + attachments_ENV.MB_translation);
                    fileTemplate.find('.remove-item').attr('data-index',i+'');
                    fileTemplate.find('.remove-item').on('click', function (e) {
                        var targetFileIndex = $(e.target).data('index');
                        const dataTransfer = new DataTransfer();
                        for (var i=0; i<currentAttachmentsList.length; i++){
                            if (i !== targetFileIndex){
                                dataTransfer.items.add(currentAttachmentsList[i]);
                            }
                        }
                        currentAttachmentsList = dataTransfer.files;
                        addFilesCards(form, currentAttachmentsList);
                    })
                    attachmentsListContainer.append(fileTemplate);
                    fileTemplate.removeClass('d-none');
                }

                if (currentAttachmentsList.length){
                    attachmentsListContainer.removeClass('d-none')
                }
            }
        });


    }

    function validateForm(form, currentAttachmentsList){
        var errors = {};
        var formFieldsTypes = ['select.form-control','textarea.form-control','input.form-control[type=text]:not(#other-product-field)',
            'input.form-control[type=number]','input.form-control[type=email]', 'input.form-control[type=date]'];
        var targetSelect = form.find('select.target-field');
        var selectedTarget = '';
        if (targetSelect.length>0){
            selectedTarget = targetSelect.val().split('_')[0];
        }else{
            selectedTarget = form.find('input.target-field').val().split('_')[0];
        }

        if (selectedTarget===''){
            errors['target'] = [];
        }else{
            formFieldsTypes.forEach((formField) => {
                form.find(formField).not('.target-field').each(function () {
                    var currentElement = $(this);
                    var elementRelatedTarget = currentElement.data('related-target').split('|');
                    if ( currentElement.data('validate-required')===true && (jQuery.inArray(selectedTarget,elementRelatedTarget)>-1 ||
                        (selectedTarget==='' && currentElement.parents('div.target_custom_data').length===0)) ){
                        var value = currentElement.val();
                        var elementName = currentElement.attr('name');
                        if(value===''){
                            errors[elementName] = [];
                        }else if (currentElement.attr('type')==='email' && !isValidEmail(value)){
                            errors[elementName] = [];
                        }
                    }
                });
            })

            var attachmentFieldArray = form.find('input#attachments-field');
            if (attachmentFieldArray.length>0){
                var attachmentField = attachmentFieldArray[0];
                var elementRelatedTarget = $(attachmentField).data('related-target').split('|');
                if ($(attachmentField).data('validate-required')===true && currentAttachmentsList.length===0 && (jQuery.inArray(selectedTarget,elementRelatedTarget)>-1)){
                    errors['custom-attachments'] = [];
                }else {
                    $.each(allFilesAreValid(form, currentAttachmentsList), function (key, value) {
                        errors[key] = value;
                    })
                }
            }

            var whichProductField = form.find('#whichProduct-field');
            if (whichProductField.length === 1){
                var relatedTarget = whichProductField.data('related-target').split('|');
                if (whichProductField.data('validate-required')===true && (jQuery.inArray(selectedTarget,relatedTarget)>-1)){
                    var fieldIsValid = false;
                    $('.single-product-wrapper', whichProductField).each(function () {
                        if (fieldIsValid === false && $(this).find('.form-control').is(':checked')){
                            fieldIsValid = true;
                        }
                    })
                    var otherProductValue = $('input.form-control#other-product-field', whichProductField).val();
                    if (fieldIsValid === false && otherProductValue!=='' && otherProductValue!=="undefined"){
                        fieldIsValid = true;
                    }

                    if (fieldIsValid === false){
                        errors['whichProduct'] = [];
                    }
                }
            }

            var radioButtons = ['.form-fields-radio-container .radio-buttons', '.acceptance-box .radio-container'];
            radioButtons.forEach((singleButton) => {
                form.find(singleButton).each(function () {
                    var thisRadio = $(this).find('input[type=radio]');
                    var validateButton = typeof thisRadio.data('related-target') !== "undefined" ?
                        jQuery.inArray(selectedTarget,thisRadio.data('related-target').split('|'))>-1
                        : true;
                    if ( validateButton && ((thisRadio.data('validate-required')===true && !thisRadio.is(':checked')) ||
                        (thisRadio.data('validate-present')===true && !(thisRadio.first()).is(':checked'))) ){
                        var radioName = thisRadio.attr('name')
                        errors[radioName] = [];
                    }
                });
            })
        }

        return errors;
    }

    function validateAttachmentsNumber(currentForm, files) {
        var errors = {};
        if (files.length>3){
            errors = {
                'custom-attachments': [],
                'attachments': [attachments_ENV.too_many_files]
            };
        }
        return errors;
    }

    function allFilesAreValid(currentForm, filesArray){
        var errors = validateAttachmentsNumber(currentForm, filesArray);
        if (Object.keys(errors).length===0){
            var totalFilesSize = 0;
            $.each(filesArray, function (index, file) {
                if (file.size>attachments_ENV.max_file_size_bytes){
                    errors = {
                        'custom-attachments': [],
                        'attachments': [attachments_ENV.exceeded_files_limit]
                    }
                    return ;
                }
                totalFilesSize = totalFilesSize + file.size;
            })

            if (Object.keys(errors).length===0 && totalFilesSize>attachments_ENV.max_post_size_bytes){
                errors = {
                    'custom-attachments': [],
                    'attachments': [attachments_ENV.exceeded_files_limit]
                }
            }
        }
        return errors;
    }

    function showErrors(form, errors, message, disableMessageAndScroll = false){

        var errorElements = [];
        var elementLowestOffest = '';

        if(Object.keys(errors).length>0){
            $.each(errors, function (elementName, elementValue) {
                if (elementName==='attachments'){
                    var errorComponent = form.find('.row.attachments-row .err');
                    var customAttachmentContainer = form.find('.row.attachments-row .custom-attachment-field-container');
                    customAttachmentContainer.addClass('is-invalid');
                    errorElements.push(customAttachmentContainer.data('label'));
                    errorComponent.html(elementValue.join(',<br>'));
                    errorComponent.removeClass('d-none');
                    if (disableMessageAndScroll===true){
                        customAttachmentContainer.find('.browse-button').focus()
                    }else {
                        if (elementLowestOffest === '' || (form.find('#'+elementLowestOffest+'-field').offset()>form.find('#'+elementName+'-field').offset()) ){
                            elementLowestOffest = elementName;
                        }
                    }
                }else {
                    var element = form.find('#'+elementName+'-field');
                    element.addClass('is-invalid');
                    errorElements.push(element.data('label'));
                    if ( disableMessageAndScroll===false && (elementLowestOffest === '' || (form.find('#'+elementLowestOffest+'-field').offset()>form.find('#'+elementName+'-field').offset())) ){
                        elementLowestOffest = elementName;
                    }
                }
            });
        }

        if (disableMessageAndScroll===false) {

            var fieldToFocus = form.find('#'+elementLowestOffest+'-field');
            if (fieldToFocus.attr('aria-hidden') === 'true' && fieldToFocus.hasClass('select2-hidden-accessible')){
                var selectToFocus = fieldToFocus.parent().find('.select2.select2-container.select2-container--default.select2-container--focus');
                if (selectToFocus.length>0){
                    selectToFocus.focus();
                }
            }else {
                fieldToFocus.focus();
            }

            var errorContainer = form.closest('.customizable-contact-form').find('.form-container-error');
            errorContainer.removeClass('d-none');

            if (message===''){
                var fieldsList = ''
                if (errorElements.length>1){
                    fieldsList = errorElements.join(', ');
                }else{
                    fieldsList = errorElements[0];
                }
                errorContainer.find('.error-container .error-full-text .error').text(fieldsList)
            }else{
                errorContainer.find('.error-container .error-full-text .error').remove()
                errorContainer.find('.error-container .error-full-text').text(message)
            }

            calculateExtraHeightAndScrollTop(errorContainer);

            if (form.find('button.g-recaptcha').length>0){
                grecaptcha.reset();
            }
        }
    }

    function calculateExtraHeightAndScrollTop(anchorElement) {
        var header = $(".nav-main");
        var nav = $(".nav-top");
        var extraHeight = 0;
        if (header.length && nav.length) {
            extraHeight = header.outerHeight()+nav.outerHeight();
        }
        $('html, body').animate({
            scrollTop: anchorElement.offset().top-extraHeight
        }, 1500);
    }

    function manageResponse(json, form) {
        if (json.success) {
            //track contact form submit
            if(window.location.pathname == ENV.contactPage){
                manageGTM.trackContactPageClick("Contact Form", "Send - " + ENV.market + " Contact form");
            }
            if (form.data('thank-you-page-type') === 'in-page'){
                form.parents("section").addClass("d-none");

                var thankYouSection = $('#'+form.attr('id')+'-thankYou-section');
                thankYouSection.removeClass('d-none');
                calculateExtraHeightAndScrollTop(thankYouSection);
            }else if (form.data('thank-you-page-type') === 'redirect'){
                window.location.replace(form.data('thank-you-page'));
            }
        } else {
            var errors = json.errors;
            if (typeof errors === 'undefined'){
                errors = [];
            }
            showErrors(form, errors, json.message)
        }

        if (form.find('button.g-recaptcha').length>0){
            grecaptcha.reset();
        }
    }

    return {
        init: init,
    };
})(jQuery);